package com.nonopn.skywatcher.app.utils

import korlibs.time.DateTime
import korlibs.time.Month
import kotlin.math.abs

object DateUtils {
    fun formatEllapsedTime(from: DateTime, to: DateTime): String {
        var delta = abs((to.unixMillisLong - from.unixMillisLong) / 1000)

        val seconds = delta % 60
        delta = (delta - seconds) / 60

        val minutes = delta % 60
        delta = (delta - minutes) / 60

        val hours = delta

        if (hours > 0) return "${hours}H ${minutes}min ${seconds}s"
        if (minutes > 0) return "${minutes}min ${seconds}s"
        if (seconds > 0) return "${seconds}s"
        return "0s"
    }
}
